import React, { useContext } from 'react';
import { Platform, Pressable, StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

const Button = ({ disabled = false, onPress, style, text, textStyle }) => {
    const {
        layout: {
            styleGuide: { buttonFontFamily, spacer4 }
        }
    } = useContext(LayoutContext);

    return (
        <Pressable disabled={disabled} onPress={onPress} style={({ pressed }) => [Styles.container, style, { opacity: pressed ? 0.5 : 1, padding: spacer4 }]}>
            <Text style={[Styles.text, textStyle, { fontFamily: buttonFontFamily, padding: spacer4 }]}>{text}</Text>
        </Pressable>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#fff',
        borderColor: '#fff',
        borderRadius: 5,
        borderWidth: 1,
        elevation: 1,
        justifyContent: 'center',
        padding: 10,
        cursor: Platform.OS.equals('web') ? 'pointer' : undefined
    },
    text: {
        color: '#fff',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16,
        letterSpacing: 0.25,
        lineHeight: Platform.OS.equals('web') ? '21pt' : 21
    }
});

Button.propTypes = {
    diabled: PropTypes.bool,
    onPress: PropTypes.func.isRequired,
    style: PropTypes.object,
    text: PropTypes.string.isRequired,
    textStyle: PropTypes.object
};

export default Button;
